import { ButtonSecondary, Text } from '@amelio/ui-library';

export interface ToastAction {
    label: string;
    onClick: () => void;
}

export interface ToastProps {
    /* Data for the toast notification */
    data: { title?: string; message?: string; action?: ToastAction };
    closeToast?: () => void;
}

export const Toast = ({ data, closeToast }: ToastProps) => {
    const { title, message, action } = data;

    return (
        <div className={'ml-2'}>
            {title && <Text weight={'semibold'}>{title}</Text>}

            {message && <Text>{message}</Text>}

            {action && (
                <ButtonSecondary
                    size={'sm'}
                    className={'mt-2'}
                    dataTestId={'toast-action-button'}
                    onClick={() => {
                        action.onClick();
                        closeToast?.();
                    }}
                >
                    {action.label}
                </ButtonSecondary>
            )}
        </div>
    );
};
